import React from "react";
import { Card, Modal, Tab, Tabs } from "react-bootstrap";
import "@assets/scss/global.scss";
import UpgradeIconSmall from "@assets/images/zap-icon.svg";
import { setRedirectionIdsArrayHandler } from "@redux/User/userDetailsSlice";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { getApiUrl } from "../../utils/baseUrl";
import ArrayListField from "../../shared/country-components/array-list-field";
import ShipmentsCompanyName from "../../shared/country-components/shipments-company-name";
import ItemNumShipmentRedirect from "../../shared/country-components/item-number-shipment-redirect";
import { hsCodeTypeDictionary } from "../../core/global/global-country-dictionary";
import ReactTooltip from "react-tooltip";
import { toast } from "react-toastify";
import LoaderImg from "@assets/images/loader.gif";
import FormatDate from "../../utils/formatDate";
import ReactCountryFlag from "react-country-flag";
import ReadMore from "../../shared/country-components/read-more";
import ConditionalComponent from "../../shared/country-components/conditional-component";
import TableComponent from "../../shared/country-components/table-component";
import trackingEventDictionary from "../../core/dictionary/tracking-event";
import HSCodeText from "../../shared/country-components/hs-code-text";
import { globalPendoEventForCompanyRedirection, commaFormaterFixed, productKeywordsFormatter } from "../../core/global/global-country-functions";
import { getViewShipmentDataDictionary as globalViewShipmentDataDictionary } from "../../core/global/global-view-shipment-handling";
import RedirectProfile from "../../shared/country-components/redirect-profile";
import { AddToFavShipmentModal } from "./AddToFavShipmentModal/AddToFavShipmentModal";
import StarKidFill from "@assets/images/icons/kidStarFill.svg";
import { profileType } from "@utils/enum";
import Notes from "@shared/notes";
import Button from "@components/base/button";
import { handleUnits, canViewIndiaIec } from "@utils/utils";
import { Info } from "react-feather";
import { ViewShipmentMirrorDatasets } from "@core/global/Mirror-datasets-view-shipment-handling";
const ARRAY_LIST_FIELDS = ["derived_shipper_jurisdiction_country", "derived_shipper_jurisdiction_country_region", "derived_is_exporter"];
class ViewShipment extends React.Component {
  state = {
    cargoContainerDataObj: [],
    shipmentShow: false,
    loading: false,
    shipperData: {},
    viewShipmentDetails: {},
    showFavModal: false,
    indentifier: null,
    customValue: null,
    isFavourite: false,
    tempViewShipmentObject: null,
    //below state is only used for mirror dataset
    tradeDirectionForBookmark: "",
    notesCount: 0,
    favouriteId: "",
    dataSource: null,
    isMirror: [],
  };
  componentDidMount() {
    if (this.props.isRecent === true) {
      this.shipmentDetailsShow();
    }
    this.setState({
      isMirror: ["russia imports", "russia exports", "indonesia imports", "indonesia exports", "brazil imports", "brazil exports", "turkey imports", "turkey exports"],
    });
    this.setState({
      viewShipmentDetails: this.props.viewShipmentDetails,
    });
  }
  // Below method is used to close view shipment popup
  shipmentDetailsClose = () => {
    globalPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabViewDetailedShipmentCancel, this.props.isRedirect, this.props.redirectingCompanyExporterId, this.props.redirectingCompanyImporterId, this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan);
    if (this.props.callNudgeHandler) this.props.callNudgeHandler();
    this.setState({
      shipmentShow: false,
      shipperData: {},
    });
    if (this.props.isRecent === true) {
      this.props.closeShipment();
    }
  };
  // End of the above code
  // Below method is used to open view shipment popup

  shipmentDetailsShow = (e) => {
    e.stopPropagation();
    globalPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabViewDetailedShipment, this.props.isRedirect, this.props.redirectingCompanyExporterId, this.props.redirectingCompanyImporterId, this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan);

    if (this.props.clearNudgePopupTimer) {
      this.props.clearNudgePopupTimer();
    }
    let tempIdentifier = "";
    let tempDate = "";
    let apiEndpoint = "";

    if (this.props?.rowData?.cell?.row?.original?.identifier) {
      tempIdentifier = this.props.rowData.cell.row.original.identifier;
      tempDate = this.props.rowData.cell.row.original[this.props.defaultData.date];
    } else {
      tempIdentifier = this.props.rowData.identifier;
      tempDate = this.props?.defaultData?.isViewShipmentURLModified ? this.props.rowData[this.props.defaultData.date] : "";
    }
    const isMultiCountry = this.props?.countryName?.toLowerCase() === "multicountry".toLowerCase();
    const isGlobalData = this.props?.countryName?.toLowerCase() === "global data".toLowerCase() && !window.location.pathname.includes("bookmarks/shipments");
    const isMirrorDataset = window.location.pathname.includes("mirror") || this.props?.defaultData?.isMirror === "MIRROR";

    if (isMultiCountry || isGlobalData || isMirrorDataset) {
      let tempViewShipmentObject;
      if (this.state.isMirror.includes(this.props.rowData.cell.row.original.alias_data_source)) {
        tempViewShipmentObject = ViewShipmentMirrorDatasets[this.props.rowData.cell.row.original.alias_data_source.toLowerCase()];
      } else {
        tempViewShipmentObject = globalViewShipmentDataDictionary(this.props.rowData.cell.row.original.alias_data_source.toUpperCase());
      }
      apiEndpoint = tempViewShipmentObject.apiUrl;
      tempDate = this.props.rowData.cell.row.original[this.props.defaultData.date];
      tempIdentifier = this.props.rowData.cell.row.original.identifier;

      this.setState({
        viewShipmentDetails: tempViewShipmentObject.viewShipmentObject,
        tempViewShipmentObject: tempViewShipmentObject.defaultKey,
        tradeDirectionForBookmark: tempViewShipmentObject.defaultKey.countryType,
      });
    } else if (window.location.pathname.includes("bookmarks/shipments")) {
      let tempViewShipmentObject;
      if (this.state.isMirror.includes(this.props.rowData.data_source + "s")) {
        tempViewShipmentObject = ViewShipmentMirrorDatasets[this.props.rowData.data_source + "s"];
      } else {
        tempViewShipmentObject = globalViewShipmentDataDictionary(this.props.analyticsCountryID.toUpperCase());
      }
      apiEndpoint = tempViewShipmentObject.apiUrl;
      tempDate = this.props.rowData?.shipment_date || "";
      tempIdentifier = this.props.rowData.company_id;

      this.setState({
        viewShipmentDetails: tempViewShipmentObject.viewShipmentObject,
        tradeDirectionForBookmark: tempViewShipmentObject.defaultKey.countryType,
      });
    } else {
      apiEndpoint = this.props.apiEndPoints.getShipmentByID;
    }
    if (tempIdentifier) {
      this.setState({ shipmentShow: true });
      this.getShipmentDetails(tempIdentifier, tempDate, apiEndpoint);
      this.props.setRedirectionIdsArrayHandler(tempIdentifier);
    } else {
      this.setState({ shipmentShow: false });
      toast.error("No details found.");
    }
  };
  // End of the above code
  // Below method is used to get the shipment details
  getShipmentDetails(id, date, apiEndPoint) {
    const payload = {
      identifier: id,
    };
    // Bookmark rows are flat records, not react-table cells, so they have no
    // cell.row.original for this branch to read - the bookmarks branch below owns
    // them. handleViewShipment already excludes bookmarks here; these two checks
    // did not, so a global-data bookmark took this branch and threw.
    if ((this?.props?.countryName?.toLowerCase() === "multicountry".toLowerCase() || this?.props?.countryName?.toLowerCase() === "global data".toLowerCase() || window.location.pathname.includes("mirror") || this.props?.defaultData?.isMirror === "MIRROR") && !window.location.pathname.includes("bookmarks/shipments")) {
      let tempViewShipmentObject;
      if (this.state.isMirror.includes(this.props.rowData.cell.row.original.alias_data_source)) {
        tempViewShipmentObject = ViewShipmentMirrorDatasets[this.props.rowData.cell.row.original.alias_data_source.toLowerCase()];
      } else {
        tempViewShipmentObject = globalViewShipmentDataDictionary(this.props.rowData.cell.row.original.alias_data_source.toUpperCase());
      }
      this.setState({
        dataSource: tempViewShipmentObject?.defaultKey?.countryShortHand?.toLowerCase() || tempViewShipmentObject?.defaultKey?.country_small.toLowerCase(),
      });
      if (apiEndPoint.includes("http") === true && tempViewShipmentObject?.isViewShipmentURLModified === true) {
        payload.date = date;
      }
    } else if (window.location.pathname.includes("bookmarks/shipments")) {
      let tempViewShipmentObject;
      if (this.state.isMirror.includes(this.props.rowData.data_source + "s")) {
        tempViewShipmentObject = ViewShipmentMirrorDatasets[this.props.rowData.data_source + "s"];
      } else {
        tempViewShipmentObject = globalViewShipmentDataDictionary(this.props.analyticsCountryID.toUpperCase());
      }
      if (apiEndPoint.includes("http") === true && tempViewShipmentObject?.isViewShipmentURLModified === true) {
        payload.date = date;
      }
    } else {
      if (apiEndPoint.includes("http") === true && this.props.defaultData.isViewShipmentURLModified === true) {
        payload.date = date;
      }
    }
    if (this?.props?.defaultData?.showBolFilter || this.props.type === "bol") {
      if (window.location.pathname.includes("bookmarks/shipments")) {
        payload.custom_value = this.props.rowData.custom_value;
      } else {
        payload.custom_value = this.props.rowData.cell.row.original[this.props.defaultData.bol_type];
      }
    }
    axios.post(apiEndPoint, payload).then((res) => {
      if (!!res.data.data && res.data.data.length > 0) {
        for (let i = 0; i < res.data.data.length; i++) {
          res.data.data[i].s_no = i + 1;
        }
      }
      this.setState({
        isFavourite: res?.data?._source?._is_favourites ? res?.data?._source?._is_favourites : res.data.data?._is_favourites,
        shipperData: apiEndPoint.includes("getSupplierData") === true ? res.data._source : res.data.data,
        indentifier: id,
        notesCount: res?.data?._source?.notes_count ? res?.data?._source?.notes_count : res?.data?.data?.notes_count ? res?.data?.data?.notes_count : 0,
        favouriteId: res?.data?._source?.favourite_id ? res?.data?._source?.favourite_id : res?.data?.data?.favourite_id ? res.data.data?.favourite_id : "",
        customValue: this.props?.rowData?.cell?.row?.original?.[this.props.defaultData.bol_type] ? this.props.rowData.cell.row.original[this.props.defaultData.bol_type] : "",
      });
      return false;
    });
  }
  // End of the above code
  // Below method is used to download the shipment details in PDF
  downloadShipmentDetails() {
    globalPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabViewDetailedShipmentDowloadPdf, this.props.isRedirect, this.props.redirectingCompanyExporterId, this.props.redirectingCompanyImporterId, this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan);
    let filteredApiUrl = "";
    let requestObj = {
      pdfData: {
        _source: this.state.shipperData,
        plan_id: this.props.currentUserPlan ? this.props.currentUserPlan : "trademo_intel_us_advanced",
      },
    };
    if ((this?.props?.countryName?.toLowerCase() === "multicountry".toLowerCase() || this?.props?.countryName?.toLowerCase() === "global data".toLowerCase() || window.location.pathname.includes("mirror") || this.props?.defaultData?.isMirror === "MIRROR") && !window.location.pathname.includes("bookmarks/shipments")) {
      let tempViewShipmentObject;
      if (this.state.isMirror.includes(this.props.rowData.cell.row.original.alias_data_source)) {
        tempViewShipmentObject = ViewShipmentMirrorDatasets[this.props.rowData.cell.row.original.alias_data_source.toLowerCase()];
      } else {
        tempViewShipmentObject = globalViewShipmentDataDictionary(this.props.rowData.cell.row.original.alias_data_source.toUpperCase());
      }
      filteredApiUrl = tempViewShipmentObject.apiUrlDownload.includes("http") === true ? tempViewShipmentObject.apiUrlDownload : getApiUrl(tempViewShipmentObject.apiUrlDownload);
    } else if (window.location.pathname.includes("bookmarks/shipments")) {
      let tempViewShipmentObject;
      if (this.state.isMirror.includes(this.props.rowData.data_source + "s")) {
        tempViewShipmentObject = ViewShipmentMirrorDatasets[this.props.rowData.data_source + "s"];
      } else {
        tempViewShipmentObject = globalViewShipmentDataDictionary(this.props.analyticsCountryID.toUpperCase());
      }
      filteredApiUrl = tempViewShipmentObject.apiUrlDownload.includes("http") === true ? tempViewShipmentObject.apiUrlDownload : getApiUrl(tempViewShipmentObject.apiUrlDownload);
    } else {
      filteredApiUrl = this.props.apiEndPoints.getShipmentDownloadData.includes("http") === true ? this.props.apiEndPoints.getShipmentDownloadData : getApiUrl(this.props.apiEndPoints.getShipmentDownloadData);
    }
    axios.post(filteredApiUrl, requestObj).then((response) => {
      let obj = document.createElement("object");
      obj.type = "application/pdf";
      obj.data = "data:application/pdf;base64," + response.data;
      document.body.appendChild(obj);
      // Insert a link that allows the user to download the PDF file
      let link = document.createElement("a");
      let fileName = `TrademoIntel_${this.props.countryName ? this.props.countryName : ""}_${this.props.countryType ? this.props.countryType : ""}`;
      link.setAttribute("id", fileName);
      link.href = "data:application/octet-stream;base64," + response.data;
      link.download = fileName + ".pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(document.getElementById(fileName));
    });
  }
  // End of the above code
  // below code is for the mapMultipleFieldData
  mapMultipleFieldData(fieldsData, responseData) {
    let returnStr = "";
    for (let i = 0; i < fieldsData.length; i++) {
      if (!!responseData[fieldsData[i]] && responseData[fieldsData[i]] !== "") {
        returnStr = returnStr + " " + responseData[fieldsData[i]];
      }
    }
    return returnStr;
  }
  // end of the above code
  render() {
    const isRedirected = this.props.showExpandIcon ? this.props.redirectionIdsArr?.includes(this.props.rowData?.company_id) : this.props.redirectionIdsArr?.includes(this.props.rowData?.identifier || this.props.rowData?.cell?.row?.original?.identifier);

    const hideIec = !canViewIndiaIec(this.props.userDetails?.userData?.email ?? "", this.props.userDetails?.creditDetails);
    const viewShipmentDetailsList = Array.isArray(this.state.viewShipmentDetails) ? this.state.viewShipmentDetails : [];
    const viewShipmentDetails = hideIec ? viewShipmentDetailsList.map((section) => (section?.data ? { ...section, data: section.data.filter((field) => !field.isIecField) } : section)) : viewShipmentDetailsList;

    return (
      <div onClick={(e) => e.stopPropagation()} className="tw-flex tw-items-center tw-justify-center">
        {this.props.isRecent === true ? (
          <span className="d-none"> </span>
        ) : this.props.showExpandIcon ? (
          <span
            onClick={(e) => {
              this.shipmentDetailsShow(e);
            }}
            className={`material-symbols-outlined tw-cursor-pointer tw-mt-1 ${isRedirected ? "tw-text-gray-500" : "tw-text-gray-900"}`}>
            zoom_out_map
          </span>
        ) : (
          <>
            <span onClick={this.shipmentDetailsShow} className={`material-symbols-outlined tw-cursor-pointer ${isRedirected ? "tw-text-gray-500" : "tw-text-gray-900"}`}>
              zoom_out_map
            </span>
          </>
        )}
        <Modal enforceFocus={false} size="xl" show={this.state.shipmentShow} onHide={this.shipmentDetailsClose} animation={false} className="view-shipment-modal">
          <Modal.Header closeButton>
            <Modal.Title>
              <div className="d-flex align-items-center">
                <span className="mr-2">Detailed Shipment</span>
                {/* {this.props.hideBookMark ? ( */}
                <Notes
                  id={this.state.favouriteId}
                  bolType={this.props.type}
                  count={this.state.notesCount}
                  profileDetails={{
                    company_name: "",
                    elastic_data_id: [this.state.indentifier],
                    trade_direction: this.props.countryType,
                    data_source: this.state.dataSource || this.props.countryName || this.props.data_source,
                  }}
                  customValue={this.state.customValue}
                  profileType={profileType.shipments}
                  type={this.props.countryType}
                  tradeDirection={this.props.countryType}
                  dataSource={this.state.dataSource || this.props.countryName || this.props.data_source}
                  setIsFavourite={(val) => {
                    this.setState({
                      isFavourite: val,
                    });
                  }}
                />
                {/* ) : null} */}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0 us-view-shipment">
            <div className="w-100">
              {!!this.state.shipperData && Object.keys(this.state.shipperData).length > 0 ? (
                <div className="row m-0">
                  {viewShipmentDetails.map((item) =>
                    !!item && !!item.isHeader && item.isHeader === true ? (
                      <div className="position-relative my-3 col-12">
                        <div className="col-md-12 p-0 ">
                          <Card className="col-md-12">
                            <div className="row">
                              {!!item.data && item.data.length > 0 ? (
                                item.data.map((itemData) =>
                                  (!!this.state.shipperData[itemData.value] && this.state.shipperData[itemData.value] !== "") || itemData.preValidate === false || !itemData.preValidate ? (
                                    <>
                                      {!!itemData.isConditionalField && itemData.isConditionalField === true ? (
                                        <div className="col-md-3 pt-3">
                                          <ConditionalComponent configData={itemData} mainData={this.state.shipperData} currentUserPlan={this.props.currentUserPlan} countryName={this.props.countryName} countryType={this.props.countryType} analyticsCountryID={this.props.analyticsCountryID} pathname={this.props.pathname} />
                                        </div>
                                      ) : itemData.hideCargo !== this.props.type ? (
                                        <div className="col-md-3 pt-3">
                                          {itemData.isThunderIcon === true ? (
                                            <span className="p-0">
                                              <img src={UpgradeIconSmall} alt="..." className="img-fluid mr-1" />
                                            </span>
                                          ) : (
                                            <></>
                                          )}
                                          <span>{itemData.label ? itemData.label : ""}</span>
                                          {!!itemData && !!itemData.infoText && itemData.infoText !== "" ? <Info className="ml-1" size={13} data-tip={itemData.infoText} /> : <></>}
                                          {itemData.hideField && this.props.currentUserPlan && this.props.currentUserPlan === "trademo_intel_us_starter__" ? (
                                            <div data-tip={`To view ${itemData.label ? itemData.label : "this field"}, you would need to upgrade to higher plan.`}>
                                              <span className="blur-effect ml-3 pl-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                              <span className="ml-1">
                                                <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                                              </span>
                                              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" />
                                            </div>
                                          ) : this.state.shipperData[itemData.value] ? (
                                            itemData.shipmentRedirect ? (
                                              <ItemNumShipmentRedirect selectedRowData={this.props.rowData} rowData={this.state.shipperData} fieldDetails={itemData} countryName={this.props.countryName} countryType={this.props.countryType} from={this.props.from || ""} />
                                            ) : !!itemData.type && itemData.type === "redirect" && itemData?.profileType ? (
                                              <div>
                                                <RedirectProfile profileType={itemData?.profileType} profileId={this.state.shipperData[itemData.redirectionID]} profileName={this.state.shipperData[itemData.value]} dataSource={this.props.analyticsCountryID} showLogo />
                                              </div>
                                            ) : itemData.isReadMore === true && itemData.isProductKeywordFormater !== true ? (
                                              <ReadMore dataContent={this.state.shipperData[itemData.value]} dataLength={itemData.readMoreLength} />
                                            ) : (
                                              <p className={`tw-capitalize ${this.state.shipperData[itemData.value] === "NA" ? "!tw-font-normal" : ""}`} data-tip={itemData.tooltip && this.state.shipperData[itemData.tooltipField] && !!itemData.tooltipPrefix ? itemData.tooltipPrefix + this.state.shipperData[itemData.tooltipField] : itemData.tooltip && this.state.shipperData[itemData.tooltipField] ? this.state.shipperData[itemData.tooltipField] : ""}>
                                                {itemData.valuePrefix ? itemData.valuePrefix : ""}
                                                {itemData.dateFormat ? (
                                                  this.state.shipperData[itemData.value] === "NA" ? (
                                                    "NA"
                                                  ) : (
                                                    FormatDate(this.state.shipperData[itemData.value], "MMM DD, YYYY")
                                                  )
                                                ) : itemData.monthFormat ? (
                                                  this.state.shipperData[itemData.value] === "NA" ? (
                                                    "NA"
                                                  ) : (
                                                    FormatDate(this.state.shipperData[itemData.value], "MMM, YYYY")
                                                  )
                                                ) : typeof this.state.shipperData[itemData.value] === "string" && !itemData.capitalize ? (
                                                  itemData.value.includes("hs_") === true ? (
                                                    itemData.hideCargo !== this.props.type ? (
                                                      <HSCodeText hsCodeFieldObject={this.state.shipperData[itemData.value]} type={hsCodeTypeDictionary.viewShipment} countryName={this.props.countryName} countryType={this.props.countryType} analyticsCountryID={this.props.analyticsCountryID} pathname={this.props.pathname} currentUserPlan={this.props.currentUserPlan} isReadMore={itemData?.isReadMoreHSCode ?? false} />
                                                    ) : (
                                                      <></>
                                                    )
                                                  ) : (
                                                    this.state.shipperData[itemData.value]
                                                  )
                                                ) : itemData.isProductKeywordFormater === true ? (
                                                  <ReadMore dataContent={productKeywordsFormatter(this.state.shipperData[itemData.value])} dataLength={itemData.readMoreLength} />
                                                ) : itemData.isCommaFormat === true && typeof this.state.shipperData[itemData.value] === "number" ? (
                                                  commaFormaterFixed(this.state.shipperData[itemData.value].toFixed(itemData.fixedValueUpto))
                                                ) : itemData.capitalize ? (
                                                  <span>{this?.state?.shipperData && itemData?.value && this?.state?.shipperData?.[itemData.value] ? this.state.shipperData[itemData.value] : "NA"}</span>
                                                ) : ARRAY_LIST_FIELDS.includes(itemData.value) && Array.isArray(this.state.shipperData[itemData.value]) ? (
                                                  <ArrayListField values={this.state.shipperData[itemData.value]} />
                                                ) : (
                                                  this.state.shipperData[itemData.value]
                                                )}
                                                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" />
                                              </p>
                                            )
                                          ) : (
                                            <div>NA</div>
                                          )}
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <></>
                                  )
                                )
                              ) : (
                                <></>
                              )}
                            </div>
                          </Card>
                        </div>
                      </div>
                    ) : (
                      <div className={"position-relative my-3 col-" + item.growValue}>
                        {!!item && !!item.isCompactHeader && item.isCompactHeader === true ? (
                          <>
                            {!!item && !!item.isConnectedColumn && item.isConnectedColumn === true ? (
                              <div className="connecting-img-container">
                                <span className="connecting-img">
                                  <img src="https://res.cloudinary.com/ddfycftwg/image/upload/v1640252167/images/website/api-integration/arrow-image_udzuwx.svg" className="mr-1" />
                                </span>
                              </div>
                            ) : (
                              <></>
                            )}
                            <Card className="compact-header ">
                              <Card.Header>
                                <span>
                                  {!!item && !!item.imgUrl && item.imgUrl !== "" ? <img src={item.imgUrl} className="mr-1" /> : <></>}
                                  {!!item && !!item.title && item.title !== "" ? item.title : ""}{" "}
                                </span>
                              </Card.Header>
                            </Card>
                            <Card>
                              <div className="d-block">
                                {!!item && !!item.data && item.data.length > 0 ? (
                                  item.data.map((itemData) =>
                                    (!!this.state.shipperData[itemData.value] && this.state.shipperData[itemData.value] !== "") || itemData.preValidate === false || !itemData.preValidate ? (
                                      itemData.hideCargo !== this.props.type ? (
                                        <div className="d-flex py-2 card-border">
                                          <div className="col-5">
                                            {itemData.isThunderIcon === true ? (
                                              <span className="p-0">
                                                <img src={UpgradeIconSmall} alt="..." className="img-fluid mr-1" />
                                              </span>
                                            ) : (
                                              <></>
                                            )}
                                            <span>{itemData.label ? itemData.label : ""}</span>
                                            {!!itemData && !!itemData.infoText && itemData.infoText !== "" ? <Info className="ml-1" size={13} data-tip={itemData.infoText} /> : <></>}
                                          </div>
                                          {(!this.state.shipperData[itemData.value] || this.state.shipperData[itemData.value] !== "") && itemData.isFieldHardcode === true && itemData.hardcodedValue && itemData.hardcodedValue !== "" && itemData.hardcodedCountryCode && itemData.hardcodedCountryCode !== "" ? (
                                            <div className="col-7 bold-data text-capitalize">
                                              {itemData.hardcodedValue}
                                              <span>
                                                <ReactCountryFlag className="trademo-search-flag ml-2" countryCode={itemData.hardcodedCountryCode} svg />
                                              </span>
                                            </div>
                                          ) : (!!this.state.shipperData[itemData.value] && this.state.shipperData[itemData.value] !== "") || (!!itemData.type && itemData.type === "redirect") ? (
                                            <div className={`col-7 ${!!itemData.type && itemData.type === "redirect" ? "" : "bold-data"} ${!!itemData.value && itemData.value.includes("email") ? "" : "text-capitalize"} d-flex`} data-tip={itemData.tooltip && this.state.shipperData[itemData.tooltipField] && !!itemData.tooltipPrefix ? itemData.tooltipPrefix + this.state.shipperData[itemData.tooltipField] : itemData.tooltip && this.state.shipperData[itemData.tooltipField] ? this.state.shipperData[itemData.tooltipField] : typeof this.state.shipperData[itemData.value] === "string" && this.state.shipperData[itemData.value].toLowerCase().length > 50 && !itemData?.isReadMore ? this.state.shipperData[itemData.value] : ""}>
                                              {!!itemData.type && itemData.type === "redirect" ? (
                                                itemData?.profileType ? (
                                                  <RedirectProfile profileType={itemData?.profileType} profileId={this.state.shipperData[itemData.redirectionID]} profileName={this.state.shipperData[itemData.value]} dataSource={this.props.analyticsCountryID} showLogo countryName={this.props.countryName} countryType={this.props.countryType} />
                                                ) : (
                                                  <ShipmentsCompanyName
                                                    name={itemData.label}
                                                    rowData={this.state.shipperData}
                                                    companyIdKey={this.props.isSalesForceRedirection ? null : itemData.companyIdKey ? itemData.companyIdKey : ""}
                                                    companyKey={itemData.companyKey ? itemData.companyKey : ""}
                                                    derivedCompanyKey={itemData.derivedCompanyKey ? itemData.derivedCompanyKey : ""}
                                                    countryName={this.props.countryName}
                                                    countryType={this.props.countryType}
                                                    type={itemData.tradeDirection}
                                                    analyticsCountryID={this.props.analyticsCountryID}
                                                    pathname={this.props.pathname}
                                                    isRedirect={this.props.isRedirect}
                                                    currentUserPlan={this.props.currentUserPlan}
                                                    shipmentConsigneeStandardizedName={trackingEventDictionary.shipmentsTabViewDetailedShipmentConsigneeStandardizedName}
                                                    shipmentShipperStandardizedName={trackingEventDictionary.shipmentsTabViewDetailedShipmentShipperStandardizedName}
                                                    redirectingCompanyExporterId={this.props.redirectingCompanyExporterId}
                                                    redirectingCompanyImporterId={this.props.redirectingCompanyImporterId}
                                                  />
                                                )
                                              ) : (
                                                <>
                                                  {itemData.valuePrefix ? itemData.valuePrefix : ""}
                                                  {itemData.isMultiFieldMapping === true ? (
                                                    this.mapMultipleFieldData(itemData.multiFieldsArr, this.state.shipperData)
                                                  ) : (
                                                    <div>
                                                      {typeof this.state.shipperData[itemData.value] === "string" && itemData.isReadMore === true ? (
                                                        <ReadMore dataContent={this.state.shipperData[itemData.value]} dataLength={itemData.readMoreLength} />
                                                      ) : // typeof (this.state.shipperData[itemData.value]) === 'string' && (itemData.label === 'Is Supplier' || itemData.label.toLowerCase() === 'is buyer' || itemData.label === 'Consignee Type' || itemData.label === 'Shipper Type') && (this.state.shipperData[itemData.value].toUpperCase() === 'N' || this.state.shipperData[itemData.value].toUpperCase() === 'NO') ? 'Logistics Provider' :
                                                      itemData.isCapitalise ? (
                                                        this.state.shipperData[itemData.value].toUpperCase()
                                                      ) : typeof this.state.shipperData[itemData.value] === "string" && itemData.label !== "Tax Identification Number" && itemData.label !== "Consignee Zipcode" ? (
                                                        this.state.shipperData[itemData.value].toLowerCase().length > 50 ? (
                                                          this.state.shipperData[itemData.value].toLowerCase().slice(0, 50) + ".."
                                                        ) : (
                                                          this.state.shipperData[itemData.value].toLowerCase()
                                                        )
                                                      ) : typeof this.state.shipperData[itemData.value] === "string" && itemData.label === "Tax Identification Number" ? (
                                                        this.state.shipperData[itemData.value].toUpperCase()
                                                      ) : ARRAY_LIST_FIELDS.includes(itemData.value) && Array.isArray(this.state.shipperData[itemData.value]) ? (
                                                        <ArrayListField values={this.state.shipperData[itemData.value]} />
                                                      ) : (
                                                        this.state.shipperData[itemData.value]
                                                      )}
                                                    </div>
                                                  )}
                                                  {itemData.countryFlag && itemData.countryCodeField && this.state.shipperData[itemData.countryCodeField] ? (
                                                    <span>
                                                      <ReactCountryFlag className="trademo-search-flag ml-2" countryCode={this.state.shipperData[itemData.countryCodeField]} svg />
                                                    </span>
                                                  ) : (
                                                    <></>
                                                  )}
                                                  {!!this.state.shipperData[itemData.value] && this.state.shipperData[itemData.value].length > 50 ? <ReactTooltip className="trademo-tooltip text-capitalize" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" multiline={true} id={"testing"} /> : ""}
                                                </>
                                              )}
                                              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" />
                                            </div>
                                          ) : (
                                            <div className="col-7">NA</div>
                                          )}
                                        </div>
                                      ) : (
                                        <></>
                                      )
                                    ) : (
                                      <></>
                                    )
                                  )
                                ) : (
                                  <></>
                                )}
                              </div>
                            </Card>
                          </>
                        ) : !!item && (item.isContainer === true || (item?.isBolContainer === true && this.props.type === "bol")) ? (
                          // Below code is for the container Details
                          <Card>
                            <Card.Header>
                              <span>
                                <img src="https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg" className="mr-1" />
                                {this.props.type === "bol" ? item.title : "Container Details"}
                              </span>
                            </Card.Header>
                            <div>
                              <Tabs defaultActiveKey={this.props.type === "bol" ? "Shipment 1" : "Container 1"} id="uncontrolled-tab-example" className="view-shipment-tab mx-3 my-2">
                                {this.state.shipperData[item.mainKey]?.length
                                  ? this.state.shipperData[item.mainKey].map((itemData, index) => (
                                      <Tab eventKey={`${this.props.type === "bol" ? "Shipment " + (index + 1) : "Container " + (index + 1)}`} title={`${this.props.type === "bol" ? "Shipment " + (index + 1) : "Container " + (index + 1)}`}>
                                        <div className="row col-12 m-0 p-0 my-3 d-flex">
                                          {item.data.map((mainData, i) => (
                                            <>
                                              {mainData.isNested === true ? (
                                                <>
                                                  {!!itemData[mainData.nestedKey] && itemData[mainData.nestedKey].length !== 0 ? (
                                                    itemData[mainData.nestedKey].map((tableData) => (
                                                      <div className="col-6">
                                                        <Card className={i > 1 ? "mt-3" : ""}>
                                                          <Card.Header>
                                                            {mainData.title} {tableData[mainData.nestedNumber] ? tableData[mainData.nestedNumber] : <></>}
                                                          </Card.Header>
                                                          <div className="d-block">
                                                            {!!mainData.childData && mainData.childData.length !== 0 ? (
                                                              mainData.childData.map((mData) => (
                                                                <>
                                                                  {mData.isTable === true ? (
                                                                    <>
                                                                      {!!tableData[mData.value] && tableData[mData.value].length !== 0 ? (
                                                                        <div className="d-flex py-2 card-border">
                                                                          <table>
                                                                            <thead>
                                                                              <tr>
                                                                                {mData.tableHeaderKey.map((tData) => (
                                                                                  <td className="px-3">{tData}</td>
                                                                                ))}
                                                                              </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                              {tableData[mData.value].map((tDData) => (
                                                                                <tr className="mt-2">
                                                                                  {mData.tableContentKey.map((xyz) => (
                                                                                    <td className="px-3 bold-data">{tDData[xyz] ? tDData[xyz] : "NA"}</td>
                                                                                  ))}
                                                                                </tr>
                                                                              ))}
                                                                            </tbody>
                                                                          </table>
                                                                        </div>
                                                                      ) : (
                                                                        <></>
                                                                      )}
                                                                    </>
                                                                  ) : (
                                                                    <div className="d-flex py-2 card-border">
                                                                      <div className="col-4">{mData.label}</div>
                                                                      {!!tableData[mData.value] && tableData[mData.value] !== "" ? (
                                                                        <>
                                                                          {mData.dynamicUnit === true ? (
                                                                            <div className="col-8 bold-data">
                                                                              {tableData[mData.value]} {!!this.state.shipperData[mData.unitField] && this.state.shipperData[mData.unitField] !== "" ? handleUnits(this.state.shipperData[mData.unitField]) : ""}
                                                                            </div>
                                                                          ) : (
                                                                            <div className="col-8 bold-data">{mData.isReadMore === true ? <ReadMore dataContent={tableData[mData.value]} dataLength={mData.readMoreLength} /> : tableData[mData.value]}</div>
                                                                          )}
                                                                        </>
                                                                      ) : (
                                                                        <div className="col-8">{mData.defaultValue}</div>
                                                                      )}
                                                                    </div>
                                                                  )}
                                                                </>
                                                              ))
                                                            ) : (
                                                              <></>
                                                            )}
                                                          </div>
                                                        </Card>
                                                      </div>
                                                    ))
                                                  ) : (
                                                    <></>
                                                  )}
                                                </>
                                              ) : mainData.isContainerDimension === true ? (
                                                <div className="col-6">
                                                  <Card>
                                                    <Card.Header>{mainData.title}</Card.Header>
                                                    <div className="d-block">
                                                      {mainData?.childData?.length
                                                        ? mainData.childData.map((containerData) => (
                                                            <div className="d-flex py-2 card-border">
                                                              <div className="col-4">{containerData.label}</div>
                                                              {!!containerData && !!containerData.infoText && containerData.infoText !== "" ? <Info className="ml-1" size={13} data-tip={containerData.infoText} /> : <></>}
                                                              {!!itemData[containerData.value] && itemData[containerData.value] !== "" ? (
                                                                <div className="col-8 bold-data">
                                                                  {containerData.isFeet === true ? Math.floor(itemData[containerData.value] / 100) + " ft " : ""} {containerData.isInch === true && itemData[containerData.value] % 100 !== 0 ? (itemData[containerData.value] % 100) + " in" : ""} {containerData.isInch !== true && containerData.isFeet !== true ? itemData[containerData.value] : ""}
                                                                </div>
                                                              ) : (
                                                                <div className="col-8">{containerData.defaultValue}</div>
                                                              )}
                                                            </div>
                                                          ))
                                                        : null}
                                                    </div>
                                                  </Card>
                                                </div>
                                              ) : item?.isBolContainer === true ? (
                                                <div className="col-12 py-2 card-border row">
                                                  <div className="col-5">{mainData.label}</div>
                                                  <div className="col-7">
                                                    <strong>
                                                      {mainData.value.includes("hs_") === true ? (
                                                        <HSCodeText HSCodeText hsCodeFieldObject={itemData[mainData.value]} type={hsCodeTypeDictionary.viewShipment} countryName={this.props.countryName} countryType={this.props.countryType} analyticsCountryID={this.props.analyticsCountryID} pathname={this.props.pathname} currentUserPlan={this.props.currentUserPlan} isReadMore={itemData?.isReadMoreHSCode ?? false}>
                                                          {" "}
                                                        </HSCodeText>
                                                      ) : (
                                                        <span>
                                                          {mainData?.valuePrefix && itemData[mainData.value] ? mainData?.valuePrefix : ""}
                                                          {itemData[mainData.value] ? itemData[mainData.value] : "NA"}
                                                          {mainData?.valueSuffix && itemData[mainData.value] ? mainData?.valueSuffix : ""}
                                                        </span>
                                                      )}
                                                    </strong>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div className="col-6">
                                                  <Card>
                                                    <Card.Header>{mainData.title}</Card.Header>
                                                    <div className="d-block">
                                                      {mainData?.childData?.length
                                                        ? mainData.childData.map((containerData) => (
                                                            <div className="d-flex py-2 card-border">
                                                              <div className="col-4">{containerData.label}</div>
                                                              {!!itemData[containerData.value] && itemData[containerData.value] !== "" ? (
                                                                <div className="col-8 bold-data">
                                                                  {containerData.isFeet === true ? Math.floor(itemData[containerData.value] / 100) + " ft " : ""} {containerData.isInch === true && itemData[containerData.value] % 100 !== 0 ? (itemData[containerData.value] % 100) + " in" : ""} {containerData.isInch !== true && containerData.isFeet !== true ? itemData[containerData.value] : ""}
                                                                </div>
                                                              ) : (
                                                                <div className="col-8">{containerData.defaultValue}</div>
                                                              )}
                                                            </div>
                                                          ))
                                                        : null}
                                                    </div>
                                                  </Card>
                                                </div>
                                              )}
                                            </>
                                          ))}
                                        </div>
                                      </Tab>
                                    ))
                                  : null}
                              </Tabs>
                            </div>
                          </Card>
                        ) : // End of the above code
                        item?.hideCargo !== this.props.type && !item?.isBolContainer ? (
                          <Card>
                            <Card.Header>
                              <span>
                                {!!item && !!item.imgUrl && item.imgUrl !== "" ? <img src={item.imgUrl} className="mr-1" /> : <></>}
                                {item?.altTitle ? item.altTitle : !!item && !!item.title && item.title !== "" && item.isTitleDynamic === true ? item.title + this.state.shipperData[item.dynamicTitle] : !!item && !!item.title && item.title !== "" ? item.title : ""}{" "}
                              </span>
                            </Card.Header>
                            <div className="d-block">
                              {!!item && !!item.data && item.data.length > 0 ? (
                                item.data.map((itemData) =>
                                  (!!this.state.shipperData[itemData.value] || itemData.preValidate === false || !itemData.preValidate) && !(itemData.isTableFiled && itemData.colOne && itemData.colTwo && itemData.value) ? (
                                    <div className="d-flex py-2 card-border">
                                      <div className="col-5">
                                        {itemData.isThunderIcon === true ? (
                                          <span className="p-0">
                                            <img src={UpgradeIconSmall} alt="..." className="img-fluid mr-1" />
                                          </span>
                                        ) : (
                                          <></>
                                        )}
                                        <span>{itemData.label ? itemData.label : ""}</span>
                                        {!!itemData && !!itemData.infoText && itemData.infoText !== "" ? <Info className="ml-1" size={13} data-tip={itemData.infoText} /> : <></>}
                                      </div>
                                      {(!!this.state.shipperData[itemData.value] && this.state.shipperData[itemData.value] !== "") || (!!itemData.type && itemData.type === "redirect") ? (
                                        <div className={`col-7 ${!!itemData.type && itemData.type === "redirect" ? "" : "bold-data"} text-capitalize ${Array.isArray(this.state.shipperData[itemData.value]) && this.state.shipperData[itemData.value]?.length > 0 ? "tw-flex tw-flex-col tw-gap-1" : ""}`} data-tip={itemData.tooltip && this.state.shipperData[itemData.tooltipField] && !!itemData.tooltipPrefix ? itemData.tooltipPrefix + this.state.shipperData[itemData.tooltipField] : itemData.tooltip && this.state.shipperData[itemData.tooltipField] ? (itemData.tooltipField2 && this.state.shipperData[itemData.tooltipField2] ? this.state.shipperData[itemData.tooltipField] + " " + this.state.shipperData[itemData.tooltipField2] : this.state.shipperData[itemData.tooltipField]) : ""}>
                                          {itemData.hideField && this.props.currentUserPlan && this.props.currentUserPlan === "trademo_intel_us_starter__" ? (
                                            <div data-tip={`To view ${itemData.label ? itemData.label : "this field"}, you would need to upgrade to higher plan.`}>
                                              <span className="blur-effect">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                              <span className="ml-1">
                                                <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                                              </span>
                                              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" />
                                            </div>
                                          ) : !!itemData.type && itemData.type === "redirect" ? (
                                            itemData?.profileType ? (
                                              <RedirectProfile profileType={itemData?.profileType} profileId={this.state.shipperData[itemData.redirectionID]} profileName={this.state.shipperData[itemData.value]} dataSource={this.props.analyticsCountryID} showLogo countryName={this.props.countryName} countryType={this.props.countryType} />
                                            ) : (
                                              <ShipmentsCompanyName name={itemData.label} rowData={this.state.shipperData} companyIdKey={this.props.isSalesForceRedirection ? null : itemData.companyIdKey ? itemData.companyIdKey : ""} companyKey={itemData.companyKey ? itemData.companyKey : ""} derivedCompanyKey={itemData.derivedCompanyKey ? itemData.derivedCompanyKey : ""} countryName={this.props.countryName} countryType={this.props.countryType} analyticsCountryID={this.props.analyticsCountryID} pathname={this.props.pathname} isRedirect={this.props.isRedirect} currentUserPlan={this.props.currentUserPlan} shipmentConsigneeStandardizedName={trackingEventDictionary.shipmentsTabViewDetailedShipmentConsigneeStandardizedName} shipmentShipperStandardizedName={trackingEventDictionary.shipmentsTabViewDetailedShipmentShipperStandardizedName} redirectingCompanyExporterId={this.props.redirectingCompanyExporterId} redirectingCompanyImporterId={this.props.redirectingCompanyImporterId} />
                                            )
                                          ) : (
                                            <>
                                              {itemData.valuePrefix ? itemData.valuePrefix : ""}
                                              {itemData.isReadMore === true ? (
                                                <ReadMore dataContent={this.state.shipperData[itemData.value]} dataLength={itemData.readMoreLength} />
                                              ) : itemData.isCommaFormat === true ? (
                                                !!itemData.fixedValueUpto && typeof this.state.shipperData[itemData.value] === "number" ? (
                                                  commaFormaterFixed(this.state.shipperData[itemData.value].toFixed(itemData.fixedValueUpto))
                                                ) : (
                                                  commaFormaterFixed(this.state.shipperData[itemData.value])
                                                )
                                              ) : itemData.isSplitNecessary === true ? (
                                                this.state.shipperData[itemData.value].split(" ").join(", ")
                                              ) : itemData.isCapitalise ? (
                                                Array.isArray(this.state.shipperData[itemData.value]) && this.state.shipperData[itemData.value]?.length > 0 ? (
                                                  this.state.shipperData[itemData.value].map((listItem, index) => (
                                                    <div key={listItem} className="tw-flex tw-gap-1">
                                                      <span>{`${index + 1}.`}</span>
                                                      <span>{`${listItem}`}</span>
                                                    </div>
                                                  ))
                                                ) : (
                                                  this.state.shipperData[itemData.value].toUpperCase()
                                                )
                                              ) : ARRAY_LIST_FIELDS.includes(itemData.value) && Array.isArray(this.state.shipperData[itemData.value]) ? (
                                                <ArrayListField values={this.state.shipperData[itemData.value]} />
                                              ) : typeof this.state.shipperData[itemData.value] === "string" && itemData.label !== "Tax Identification Number" && itemData.label !== "Consignee Zipcode" ? (
                                                itemData.value.includes("hs_") === true ? (
                                                  <HSCodeText hsCodeFieldObject={this.state.shipperData[itemData.value]} type={hsCodeTypeDictionary.viewShipment} countryName={this.props.countryName} countryType={this.props.countryType} analyticsCountryID={this.props.analyticsCountryID} pathname={this.props.pathname} currentUserPlan={this.props.currentUserPlan} isReadMore={itemData?.isReadMoreHSCode ?? false}>
                                                    {" "}
                                                  </HSCodeText>
                                                ) : (
                                                  this.state.shipperData[itemData.value].toLowerCase()
                                                )
                                              ) : typeof this.state.shipperData[itemData.value] === "string" && itemData.label === "Tax Identification Number" ? (
                                                this.state.shipperData[itemData.value].toUpperCase()
                                              ) : (
                                                this.state.shipperData[itemData.value]
                                              )}
                                              {itemData.dynamicUnit === true && this.state.shipperData[itemData.unitField] ? <span className="text-no-transform"> {handleUnits(this.state.shipperData[itemData.unitField])}</span> : <></>}
                                              {itemData.valueSuffix ? itemData.valueSuffix : ""}
                                              {itemData.countryFlag && itemData.countryCodeField && this.state.shipperData[itemData.countryCodeField] ? (
                                                <span>
                                                  <ReactCountryFlag className="trademo-search-flag ml-2" countryCode={this.state.shipperData[itemData.countryCodeField]} svg />
                                                </span>
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          )}
                                        </div>
                                      ) : (
                                        <div className="col-7">NA</div>
                                      )}
                                    </div>
                                  ) : // below code block is for table in argentina view shipment
                                  !!itemData.isTableFiled && itemData.colOne && itemData.colTwo && itemData.value ? (
                                    <TableComponent label={itemData.label} tableData={this.state.shipperData[itemData.value]} colOne={itemData.colOne} colTwo={itemData.colTwo} />
                                  ) : (
                                    <></>
                                  )
                                )
                              ) : (
                                <></>
                              )}
                            </div>
                          </Card>
                        ) : (
                          <></>
                        )}
                      </div>
                    )
                  )}
                </div>
              ) : (
                <div className="row">
                  <div className="no-search-data-container text-center">
                    <img src={LoaderImg} alt="description of gif" />
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="sticky-download-footer">
            {this.state.shipperData && Object.keys(this.state.shipperData).length && !this.props.hideBookMark ? (
              <div>
                <Button
                  className="mx-2"
                  variant={"primaryLightWithIcon"}
                  size={"large"}
                  onClick={() => {
                    this.setState({
                      showFavModal: true,
                    });
                    globalPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabViewAddToFavorites, this.props.isRedirect, this.props.redirectingCompanyExporterId, this.props.redirectingCompanyImporterId, this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan);
                  }}>
                  {this.state.isFavourite ? <img className="bookmarked_icon" src={StarKidFill} width={20} height={20} /> : <span className="material-symbols-outlined">kid_star</span>}
                  <span className="ml-1">{this.state.isFavourite ? "Bookmarked" : "Bookmark"}</span>
                </Button>
              </div>
            ) : null}

            {!!this.state.shipperData && Object.keys(this.state.shipperData).length && this.props.type !== "bol" ? (
              <Button onClick={this.downloadShipmentDetails.bind(this)} className="mx-2" variant={"primaryWithIcon"} size={"large"}>
                <span className="material-symbols-outlined">cloud_download</span>
                <span className="ml-1">Download</span>
              </Button>
            ) : (
              <></>
            )}
          </Modal.Footer>
        </Modal>
        <AddToFavShipmentModal
          showFavModal={this.state.showFavModal}
          setShowFavModal={(val) => {
            this.setState({
              showFavModal: val,
            });
          }}
          row={this.props.rowData}
          defaultData={this.props.defaultData}
          identifier={this.state.indentifier}
          customValue={this.state.customValue}
          bolType={this.props.type}
          tempViewShipmentObject={this.state.tempViewShipmentObject}
          resetTempViewShipmentObject={() => {
            this.setState({
              resetTempViewShipmentObject: null,
            });
          }}
          setIsFavourite={() => {
            this.setState({
              isFavourite: true,
            });
          }}
          tradeDirectionForBookmark={this.state.tradeDirectionForBookmark}
        />
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { userDetails, shipmentDetails } = state;
  return { userDetails: userDetails, shipmentDetails: shipmentDetails, redirectionIdsArr: userDetails?.redirectionIdsArr ?? [] };
}
const mapDispatchToProps = {
  setRedirectionIdsArrayHandler: (data) => setRedirectionIdsArrayHandler(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewShipment));
